import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { sixYardAxios } from '../../sixYardAxios';
import classes from './forgotPassword.module.css';
import InputField from '../../components/containers/inputField/inputField';
import { connect } from 'react-redux';
import * as actions from "../../store/actions/index";
import PromptMessage from '../../components/containers/promptMessage/promptMessage';
import qs from "qs";

const ForgotPassword = (props) => {
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [controls, setControls] = useState({
    email: {
      elementType: "input",
      elementConfig: {
        type: "email",
        placeholder: "Enter email",
      },
      value: "",
      label: "Email",
      validation: {
        required: true,
        isEmail: true
      },
      valid: false,
      touched: false
    }
  });
  const formElementsArray = [];
  for (let key in controls) {
    formElementsArray.push({
      id: key,
      config: controls[key]
    });
  }
  const form = formElementsArray.map((formElement, i) => (
    <div key={i} className={classes.FormGroup}>
      <InputField
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        invalid={!formElement.config.valid}
        shouldValidate={formElement.config.validation}
        touched={formElement.config.touched}
        withRemove={false}
        label={formElement.config.label}
        changed={event => inputChangedHandler(event, formElement.id)}
      />
    </div>
  ));
  const checkValidity = ((value, rules) => {
    let isValid = true;
    if (!rules) {
      return true;
    }

    if (rules.required) {
      value = typeof value === 'string' ? value.trim() : value;
      isValid = value !== "" && isValid;
    }

    if (rules.isEmail) {
      const pattern = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
      isValid = pattern.test(value) && isValid;
    }
    return isValid;
  })
  const inputChangedHandler = (event, controlName) => {
    const updatedControls = {
      ...controls,
      [controlName]: {
        ...controls[controlName],
        value: event.target.value,
        valid: checkValidity(
          event.target.value,
          controls[controlName].validation
        ),
        touched: true
      }
    };
    setControls(updatedControls);
  };
  const clearControls = () => {
    const updatedControls = {
        ...controls
    };
    for (let key in controls) {
        updatedControls[key] = {
            ...controls[key],
            value: "",
            valid: false,
            touched: false
        };
    }
    setControls(updatedControls);
};
  const submitHandler = event => {
    event.preventDefault();
    sixYardAxios
      .post("/auth/forgot-password", qs.stringify({ email: controls.email.value }))
      .then(res => {
        clearControls();
        setSuccess(res.data.data.message);
      })
      .catch(error => {
        setError(error.response.data.message);
      });
  };
  useEffect(() => {
    props.isAuthenticated && navigate('/')
  }, [props.isAuthenticated]);
  return (
    <div className={classes.Container}>
      <h1>Forgot Password</h1>
      <div className={classes.FormLayout}>
        <form className={classes.Form} onSubmit={(e) => submitHandler(e)}>
          {form}
          <button type="submit" className={classes.Button}>SEND</button>
        </form>
      </div>
      {error && <PromptMessage message={error} status='Oops' button='CLOSE' click={() => setError(false)} />}
      {success && <PromptMessage message={success} status='CONGRATULATIONS' success button='CLOSE' click={() => setSuccess(false)} />}
    </div>
  )
}

// const mapDispatchToProps = dispatch => {
//   return {
//     onAuth: (email, password, language) => dispatch(actions.auth(email, password, language)),
//     onForgetPassword: (email) => dispatch(actions.forgetPassword(email)),
//   };
// };
const mapStateToProps = state => ({
  isAuthenticated: state.auth.token !== null,
  email: state.profile.userProfile.email,
  // loading: state.auth.loading,
  // error: state.auth.error,
  // token: state.auth.token,
  // user: state.auth.user,
  // language: state.home.selected_language === 1 ? "en" : "ar",
  // success_message: state.auth.success_message,
});
export default connect(mapStateToProps)(ForgotPassword);